import defaultConfig from './default-config';
const envConfig = require(`./${process.env.NODE_ENV}-config`).default;

export default Object.assign({ env: process.env.NODE_ENV }, defaultConfig, envConfig);
